import { render } from "./RoleChange.vue?vue&type=template&id=70cf0dbf&scoped=true"
import script from "./RoleChange.vue?vue&type=script&lang=js"
export * from "./RoleChange.vue?vue&type=script&lang=js"

import "./RoleChange.vue?vue&type=style&index=0&id=70cf0dbf&lang=css"
import "./RoleChange.vue?vue&type=style&index=1&id=70cf0dbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70cf0dbf"]])

export default __exports__